module.exports = __webpack_public_path__ + "img/40_38_032_360.56d27923.jpg";